import { useMemo, type PropsWithChildren } from 'react'
import {
  FeatureFlagsProvider as FeatureFlagsClientProvider,
  resolveProviderConfig,
} from '@DigitalZoneApp/feature-flags/front'

import { useAuth } from './AuthContext'

/**
 * Wires GrowthBook into the dashboard.
 */
export function FeatureFlagsProvider({ children }: PropsWithChildren) {
  const { user, tokenParsed } = useAuth()

  const config = useMemo(() => {
    const roles = tokenParsed?.realm_access?.roles ?? []

    return resolveProviderConfig({
      user: {
        id: (tokenParsed?.userId as string) ?? tokenParsed?.sub ?? '',
        traits: {
          username: user?.username ?? '',
          email: user?.email ?? '',
          roles,
        },
      },
    })
  }, [user, tokenParsed])

  return <FeatureFlagsClientProvider config={config}>{children}</FeatureFlagsClientProvider>
}
